<template>
  <div class="rigth_Infwarp">
    <el-card style="height:100%">
      <p>工作情况人口比</p>
      <div class="infro" ref="MyEcharts"></div>
    </el-card>
  </div>
</template>

<script>
import { workPrectInfo } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.getInEchart();
  },
  methods: {
    async getInEchart() {
      const { code, data, msg } = await workPrectInfo();
      // console.log(data, "工作人口比例");
      if (code == 200) {
        let gitinfo = {
          cnt: [],
          cnt2: [],
          cnt3: [],
          house: [],
          title: [],
        };
        for (const item of data) {
          gitinfo.cnt.push(item.cnt);
          gitinfo.cnt2.push(item.cnt2);
          gitinfo.cnt3.push(item.cnt3);
          gitinfo.house.push(item.house);
          let ifno = gitinfo.title.indexOf(item.title);
          if (ifno == -1) {
            gitinfo.title.push(item.title, item.title2, item.title3);
          }
          // gitinfo.quarter.push(item.quarter);
        }
        this.getInfo(gitinfo);
      }
    },
    getInfo(getinfo) {
      let myehcarts = this.$echarts.init(this.$refs.MyEcharts);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          data: getinfo.title,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: getinfo.house,
          axisTick: { show: false },
          margin: 10,
        },
        series: [
          {
            name: getinfo.title[0],
            type: "bar",
            stack: "total",
            barWidth: 30,
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              color: "#4E31DF",
            },
            data: getinfo.cnt,
          },
          {
            name: getinfo.title[1],
            type: "bar",
            stack: "total",
            itemStyle: {
              color: "#618DFA",
            },
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: getinfo.cnt2,
          },
          {
            name: getinfo.title[2],
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            itemStyle: {
              color: "#9DB9FF",
            },
            emphasis: {
              focus: "series",
            },
            data: getinfo.cnt3,
          },
        ],
      };
      myehcarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.rigth_Infwarp {
  height: 450px;
  margin: 10px 0;
  .el-card__body {
    height: 100%;
    .infro {
      height: 90%;
    }
  }
}
</style>
